import { eventsBreadcrumbs } from './events/breadcrumb';
import { contactsBreadcrumbs } from './contacts/breadcrumb';
import { formsBreadcrumbs } from './forms/breadcrumb';
import { ngoBreadcrumbs } from './ngo/breadcrumb';
import { paymentBreadcrumbs } from './payment/breadcrumb';
import { programBreadcrumbs } from './program/breadcrumb';
import { reportBreadcrumbs } from './report/breadcrumb';
import { systemBreadcrumbs } from './system/breadcrumb';
import { jobBreadcrumbs } from './job/breadcrumb';
import { Breadcrumb } from '../types';

const otherBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'onboarding',
		{
			name: 'onboarding',
			to: '/onboarding',
			i18nKey: 'breadcrumb.onboarding',
		},
	],
	['home', { name: 'home', to: '/', i18nKey: 'breadcrumb.home' }],
	[
		'myProgramItems',
		{
			name: 'myProgramItems',
			to: '/my-program-items',
			i18nKey: 'breadcrumb.myProgramItems',
		},
	],
	[
		'inbox',
		{
			name: 'inbox',
			to: '/inbox',
			i18nKey: 'breadcrumb.inbox',
		},
	],
	[
		'notification-settings',
		{
			name: 'notification-settings',
			to: '/inbox/notification-settings',
			i18nKey: 'breadcrumb.notificationSettings',
		},
	],
	[
		'profile',
		{ name: 'profile', to: '/profile', i18nKey: 'breadcrumb.profile' },
	],
	[
		'changePassword',
		{
			name: 'changePassword',
			to: '/change-password',
			i18nKey: 'breadcrumb.changePassword',
		},
	],
]);

export {
	eventsBreadcrumbs,
	contactsBreadcrumbs,
	formsBreadcrumbs,
	ngoBreadcrumbs,
	paymentBreadcrumbs,
	programBreadcrumbs,
	reportBreadcrumbs,
	systemBreadcrumbs,
	jobBreadcrumbs,
	otherBreadcrumbs,
};
